export const getUrlInfo = (url: string) => {
  const urlObject = new URL(url);

  return {
    url: urlObject,
    searchParams: urlObject.searchParams,
    pathname: urlObject.pathname,
  };
};
